import type { ITagRequest } from "@/types"
import { axios } from "@/axios"

export async function addTags(tagRequest: ITagRequest, eventVaultId?: number) {
  if (!eventVaultId)
    throw new Error("Missing Event Vault Id: Unable to call `addTags`.")

  const response = await axios.post(`api/${eventVaultId}/tags/addtag`, tagRequest)

  return response.data?.Message
}
